import { LaunchPinwheelFlowActionFragment } from 'services/graphql/fragments/Fragments';
import { AnalyticsEventFragment } from 'services/graphql/fragments/HomeTilesContentFragment';
import { gql } from 'urql';

const VXLTextFragment = gql`
  fragment VXLTextFragment on VXLText {
    copy
    style {
      fontStyle
      color
    }
  }
`;

const FullWidthTextComponentFragment = gql`
  fragment FullWidthTextComponentFragment on FullWidthTextComponent {
    id
    maxLines
    textAlignment
    text {
      ...VXLTextFragment
    }
  }
`;

const IconStyleDictionaryFragment = gql`
  fragment IconStyleDictionaryFragment on IconStyleDictionary {
    __typename
    id
    iconKey
    fallbackURL
    tint
    size
  }
`;

const SpacingComponentFragment = gql`
  fragment SpacingComponentFragment on SpacingComponent {
    id
    spacing
  }
`;

const IllustrationStyleDictionaryFragment = gql`
  fragment IllustrationStyleDictionaryFragment on IllustrationStyleDictionary {
    __typename
    id
    illustrationKey
    fallbackURL
  }
`;

const VXLHairlineComponentFragment = gql`
  fragment VXLHairlineComponentFragment on VXLHairlineComponent {
    id
    color
  }
`;

const ButtonComponentFragment = gql`
  fragment VXLButtonFragment on VXLButton {
    __typename
    copy {
      # we don't support custom text on the vxl buttons so only request copy value
      ...VXLTextFragment
    }
    horizontalLayout
    verticalLayout
    onDarkBackground
    style
    isEnabled
  }

  fragment ButtonComponentFragment on ButtonComponent {
    __typename
    id
    button {
      ...VXLButtonFragment
    }
    onClick {
      ...ButtonComponentActionResultFragment
    }
  }

  fragment ButtonComponentActionResultFragment on ButtonComponentActionResult {
    __typename
    ...LaunchPinwheelFlowActionFragment
  }
`;

const SDColorBackgroundContainerFragment = gql`
  fragment SDColorBackgroundContainerFragment on SDColorBackgroundContainer {
    __typename
    id
    fillColor
    children {
      __typename
      ...FullWidthTextComponentFragment
      ...SpacingComponentFragment
    }
    bottomBorderImage {
      __typename
      ...IllustrationStyleDictionaryFragment
    }
  }
`;

const HtmlComponentFragment = gql`
  fragment HtmlComponentFragment on HtmlComponent {
    id
    html
    boldStyle {
      fontStyle
      color
    }
    linkStyle {
      fontStyle
      color
    }
    textStyle {
      fontStyle
      color
    }
    linkActions {
      __typename
      ... on OpenPdfUrlAction {
        id
        url
        analyticsEvent {
          ...AnalyticsEventFragment
        }
      }
    }
  }
`;

const IconFullWidthTextComponentFragment = gql`
  fragment IconFullWidthTextComponentFragment on IconFullWidthTextComponent {
    __typename
    id
    title {
      __typename
      ...VXLTextFragment
    }
    subtitle {
      __typename
      ...VXLTextFragment
    }
    iconBackground
    icon {
      __typename
      ...IconStyleDictionaryFragment
    }
  }
`;

const VXLSeparatedVerticalStackContainerFragment = gql`
  fragment VXLSeparatedVerticalStackContainerChildFragment on VXLSeparatedVerticalStackContainerChild {
    id
    content {
      __typename
      ...VXLSeparatedVerticalStackContainerChildResultFragment
    }
    onClick {
      __typename
      ...VXLSeparatedVerticalStackContainerChildActionFragment
    }
  }

  fragment VXLSeparatedVerticalStackContainerFragment on VXLSeparatedVerticalStackContainer {
    __typename
    id
    items {
      __typename
      ...VXLSeparatedVerticalStackContainerChildFragment
    }
  }

  fragment VXLSeparatedVerticalStackContainerChildResultFragment on VXLSeparatedVerticalStackContainerChildResult {
    # ...SDProductStatusRowComponentFragment
    ...ButtonComponentFragment
    ...FullWidthTextComponentFragment
    ...SpacingComponentFragment
    ...HtmlComponentFragment
  }

  fragment VXLSeparatedVerticalStackContainerChildActionFragment on VXLSeparatedVerticalStackContainerChildAction {
    __typename
  }
`;

const SDScrollableScreenFragment = gql`
  fragment SDScrollableScreenFragment on SDScrollableScreen {
    topBarColor
    body {
      __typename
      ...FullWidthTextComponentFragment
      ...SDColorBackgroundContainerFragment
      # ...VXLFullWidthAlignedImageTextFragment
      ...VXLHairlineComponentFragment
      ...IconFullWidthTextComponentFragment
      ...HtmlComponentFragment
      ...SpacingComponentFragment
      ...ButtonComponentFragment
      ...VXLSeparatedVerticalStackContainerFragment
    }
    footer {
      ...ButtonComponentFragment
      ...SpacingComponentFragment
    }
    displayAnalytics {
      ...AnalyticsEventFragment
    }
  }
`;

const FetchDirectDepositBenefits = gql`
  ${SDScrollableScreenFragment}
  ${VXLTextFragment}
  ${FullWidthTextComponentFragment}
  ${IllustrationStyleDictionaryFragment}
  ${IconStyleDictionaryFragment}
  ${SDColorBackgroundContainerFragment}
  ${IconFullWidthTextComponentFragment}
  ${HtmlComponentFragment}
  ${VXLSeparatedVerticalStackContainerFragment}
  ${VXLHairlineComponentFragment}

  ${ButtonComponentFragment}
  ${SpacingComponentFragment}
  ${AnalyticsEventFragment}
  ${LaunchPinwheelFlowActionFragment}

  query FetchDirectDepositBenefits {
    directDepositBenefits {
      __typename
      ...SDScrollableScreenFragment
      ... on DirectDepositBenefitsError {
        code
        message
        title
      }
    }
  }
`;

export default FetchDirectDepositBenefits;
